import { Box, Checkbox, CircularProgress, Container, CssBaseline, FormControlLabel, Grid, Modal, Paper, Table, TableBody, TableCell, TableHead, TableRow, styled, tableCellClasses } from '@mui/material';
import React from 'react'
import { Component } from 'react'
import Constantes from '../php/Constantes';


const StyledTableCell = styled (TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.common.black,
      color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
}));
  
const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#F4F6F6',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
}));

const styleModal = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 500,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};


let desc = '';
let entradaIn = '';
let salidaIn = '';
class ConsultasInformesSV extends Component {
    constructor(props){
        super(props);
        this.state = {
            numeroNombre: [],
            lugaresTra: [],
            lugarCentral: [],
            codigosInforme: [],
            todosInformes: [],
            rechazados: [],
            notificados: [],
            pendientesJefe: [],
            pendientesSV: [],
            pendientesPersonal: [],
            pendientesjefeRRHH: [],
            pendienteNotificacion: [],
            horasEntradas: [],
            anulado: [],
            errores: null,
            notificaciones: null,

            checkInforme: {
                todo: true,
                rechazado: false,
                notificado: false,
                pendientesJefe: false,
                pendientesSV: false,
                pendientesPersonal: false,
                pendientesjefeRRHH: false,
                pendienteNotificacion: false,
                anulado: false,
            },

            busqueda: {
                numeroFuncionario: '',
                nombreFuncionario: '',
                codigo: '',
                ubicacion: '',
                ubicacionCentral: '',
                anio: '',
                mes: '',
                desde: '',
            },

            consulta: false,
            loading: false,
            consultaEspecifica: false,
            consultaEspecificaSuspender: false,
            datoEspecifico: {},

            imagenMostrar: {},
            imagenMostrarModal: false,
            modalCancelar: false,
        }
        this.manejarCambiosDatos = this.manejarCambiosDatos.bind(this);
        this.manejoEnvioConsulta = this.manejoEnvioConsulta.bind(this);
        this.manejarConsultaInforme = this.manejarConsultaInforme.bind(this);
        this.cambioListadoConsulta = this.cambioListadoConsulta.bind(this);
        this.manejarModalImagen = this.manejarModalImagen.bind(this);
        this.manejarCerrarModal = this.manejarCerrarModal.bind(this);
        this.manejarAtrasEspecifica = this.manejarAtrasEspecifica.bind(this);
        this.manejarAtras = this.manejarAtras.bind(this);
    }
    async componentDidMount(){
        const numNom = await fetch(`${Constantes.RUTA_API}/obtener_numerosNombre.php`);
        const datosNumNom = await numNom.json();
        this.setState({
            numeroNombre: datosNumNom,
        });

        const lugar = await fetch(`${Constantes.RUTA_API}/obtener_lugaresTrabajo.php`);
        const datoLugar = await lugar.json();
        this.setState({
            lugaresTra: datoLugar,
        });


        const lugarCentral = await fetch(`${Constantes.RUTA_API}/obtener_ubicacionesCentral.php`);
        const datoLugarCentral = await lugarCentral.json();
        this.setState({
            ubicacionesCentral: datoLugarCentral,
        });

        this.setState({
            codigosInforme: [
                {
                    idCodigosInformesPersonal: 2,
                    descripcion: 'ANTIGÜEDAD',
                },
                {
                    idCodigosInformesPersonal: 1,
                    descripcion: 'REGLAMENTARIA',
                },
                {
                    idCodigosInformesPersonal: 57,
                    descripcion: 'LICENCIA EXTRAORDINARIA COVID',
                },
            ]
        })

        const ent = await fetch(`${Constantes.RUTA_API}/obtener_entradas.php`);
        const datosEntrada = await ent.json();
        this.setState({
            horasEntradas: datosEntrada,
        });
    }
    render(){
        return (
            <>
                <h3>Informes</h3>
                {this.state.notificaciones ? (<div className="alert alert-success" > {this.state.notificaciones}</div>) : null}
                {this.state.errores ? (<div className='alert alert-danger'> {this.state.errores}</div>) : null}
                {this.state.loading
                ?
                    <div style={{placeItems: 'center'}}>
                        <Box sx={{alignItems: 'center'}}>
                            <CircularProgress/>
                        </Box>
                    </div>
                :
                    null
                }
                <br/>
                {this.state.consulta && (!this.state.consultaEspecifica) && (!this.state.consultaEspecificaSuspender) && (!this.state.modalCancelar)
                ?
                    <Container style={{backgroundColor: '#F2F3F4'}}>
                        <FormControlLabel label='Todo' control={<Checkbox checked={this.state.checkInforme.todo} onChange={this.cambioListadoConsulta} id='todo'  inputProps={{ 'aria-label': 'controlled' }} />  }/>
                        <FormControlLabel label='Notificados' control={<Checkbox checked={this.state.checkInforme.notificado} onChange={this.cambioListadoConsulta} id='notificado'  inputProps={{ 'aria-label': 'controlled' }} />  }/>
                        <FormControlLabel label='Rechazados' control={<Checkbox checked={this.state.checkInforme.rechazado} onChange={this.cambioListadoConsulta} id='rechazado'  inputProps={{ 'aria-label': 'controlled' }} />  }/>
                        <FormControlLabel label='Pendientes Jefe Departamento' control={<Checkbox checked={this.state.checkInforme.pendientesJefe} onChange={this.cambioListadoConsulta} id='pendientesJefe'  inputProps={{ 'aria-label': 'controlled' }} />  }/>
                        <FormControlLabel label='Pendientes S.V.' control={<Checkbox checked={this.state.checkInforme.pendientesSV} onChange={this.cambioListadoConsulta} id='pendientesSV'  inputProps={{ 'aria-label': 'controlled' }} />  }/>
                        <FormControlLabel label='Pendientes Personal' control={<Checkbox checked={this.state.checkInforme.pendientesPersonal} onChange={this.cambioListadoConsulta} id='pendientesPersonal'  inputProps={{ 'aria-label': 'controlled' }} />  }/>
                        <FormControlLabel label='Pendientes Jefe RRHH' control={<Checkbox checked={this.state.checkInforme.pendientesjefeRRHH} onChange={this.cambioListadoConsulta} id='pendientesjefeRRHH'  inputProps={{ 'aria-label': 'controlled' }} />  }/>
                        <FormControlLabel label='Pendientes Notificación' control={<Checkbox checked={this.state.checkInforme.pendienteNotificacion} onChange={this.cambioListadoConsulta} id='pendienteNotificacion'  inputProps={{ 'aria-label': 'controlled' }} />  }/>
                        <FormControlLabel label='Solicitud Anulada' control={<Checkbox checked={this.state.checkInforme.anulado} onChange={this.cambioListadoConsulta} id='anulado'  inputProps={{ 'aria-label': 'controlled' }} />  }/>
                    </Container>
                :
                    null
                }
                {this.state.consulta
                ?
                    null
                :
                    <Container style={{backgroundColor: '#F2F3F4'}}>
                        <Table id="tablaConsulta">
                            <TableHead>
                                <TableRow>
                                    <StyledTableCell>Informe</StyledTableCell>
                                    <StyledTableCell>Número</StyledTableCell>
                                    <StyledTableCell>Nombre</StyledTableCell>
                                    <StyledTableCell>Departamento</StyledTableCell>
                                    {this.state.busqueda.ubicacion === '0' ? <StyledTableCell>Central</StyledTableCell> : null}
                                    <StyledTableCell>Desde</StyledTableCell>
                                    <StyledTableCell></StyledTableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                <StyledTableRow>
                                    <StyledTableCell>
                                        <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='codigo'  value={this.state.busqueda.codigo} onChange={this.manejarCambiosDatos}>
                                            <option value=''></option>
                                            {this.state.codigosInforme.map((name) =>
                                                <option
                                                key={name.idCodigosInformesPersonal}
                                                value={name.idCodigosInformesPersonal}
                                                >{name.descripcion}</option>
                                                )}
                                        </select>
                                    </StyledTableCell>
                                    <StyledTableCell><input style={{width:"100%", border:"2px solid #D6EAF8"}} type="text" id='numeroFuncionario' value={this.state.busqueda.numeroFuncionario} onChange={this.manejarCambiosDatos}/></StyledTableCell>
                                    <StyledTableCell>{this.state.busqueda.nombreFuncionario}</StyledTableCell>
                                    <StyledTableCell>
                                        <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='ubicacion'  value={this.state.busqueda.ubicacion} onChange={this.manejarCambiosDatos}>
                                            <option value=''>UBICACION</option>
                                            {this.state.lugaresTra.map((name) =>
                                                <option
                                                key={name.idLugaresTrabajo}
                                                value={name.idLugaresTrabajo}
                                                >{name.lugar}</option>
                                                )}
                                        </select>
                                    </StyledTableCell>
                                    {this.state.busqueda.ubicacion === '0'
                                    ?
                                        <StyledTableCell>
                                            <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='ubicacionCentral'  value={this.state.busqueda.ubicacionCentral} onChange={this.manejarCambiosDatos}>
                                                <option value=''></option>
                                                {this.state.ubicacionesCentral.map((name) =>            
                                                    <option
                                                    key={name.idUbicacionesCentral}
                                                    value={name.idUbicacionesCentral}
                                                    >{name.descripcion}
                                                </option>
                                                    )}
                                            </select>
                                        </StyledTableCell>
                                    :
                                        null
                                    }
                                    <StyledTableCell><input min={'1000-01-01'} max={'9999-12-31'} style={{width:"100%", border:"2px solid #D6EAF8"}} type="date" id='desde' value={this.state.busqueda.desde} onChange={this.manejarCambiosDatos}/></StyledTableCell>
                                    <StyledTableCell><button className="btn btn-outline-danger mx-2" type='button' onClick={() => this.manejoEnvioConsulta()}>Confirmar</button></StyledTableCell>
                                </StyledTableRow>
                            </TableBody>
                        </Table>
                    </Container>
                }
                {this.state.consulta && this.state.checkInforme.todo && (!this.state.consultaEspecifica) && (!this.state.consultaEspecificaSuspender) && (!this.state.modalCancelar)
                ?
                    <Container  style={{backgroundColor: '#F2F3F4', minWidth:"100%"}}>
                        <Table sx={{maxWidth: '100%'}} id="tablaConsulta">
                            <TableHead>
                                <TableRow>
                                    <StyledTableCell>Informe</StyledTableCell>
                                    <StyledTableCell>Estado</StyledTableCell>
                                    <StyledTableCell>Año</StyledTableCell>
                                    <StyledTableCell>Número</StyledTableCell>
                                    <StyledTableCell>Nombre</StyledTableCell>
                                    <StyledTableCell>Desde</StyledTableCell>
                                    <StyledTableCell>Hasta</StyledTableCell>
                                    <StyledTableCell></StyledTableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {this.state.todosInformes.map((name) => (
                                    <StyledTableRow key={name.idInformes}>
                                        {this.state.codigosInforme.map((name2) => {
                                            if(name2.idCodigosInformesPersonal === name.codigo){
                                                desc = name2.descripcion;
                                            }
                                        })}
                                        <StyledTableCell>{desc}</StyledTableCell>
                                        <StyledTableCell>{name.estado}</StyledTableCell>
                                        <StyledTableCell>{name.anio}</StyledTableCell>
                                        <StyledTableCell>{name.numeroFuncionario}</StyledTableCell>
                                        <StyledTableCell>{name.nombreFuncionario}</StyledTableCell>
                                        <StyledTableCell>{name.desde}</StyledTableCell>
                                        <StyledTableCell>{name.hasta}</StyledTableCell>
                                        <StyledTableCell><button className="btn btn-outline-success mx-2" type='button' onClick={() => this.manejarConsultaInforme(name)}>Consultar</button></StyledTableCell>
                                    </StyledTableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </Container>
                :
                    null
                }
                {this.state.consulta && this.state.checkInforme.rechazado && (!this.state.consultaEspecifica) && (!this.state.consultaEspecificaSuspender) && (!this.state.modalCancelar)
                ?
                    <Container style={{backgroundColor: '#F2F3F4'}}>
                        <Table sx={{minWidth: 700}} id="tablaConsulta">
                            <TableHead>
                                <TableRow>
                                    <StyledTableCell>Informe</StyledTableCell>
                                    <StyledTableCell>Estado</StyledTableCell>
                                    <StyledTableCell>Año</StyledTableCell>
                                    <StyledTableCell>Número</StyledTableCell>
                                    <StyledTableCell>Nombre</StyledTableCell>
                                    <StyledTableCell>Desde</StyledTableCell>
                                    <StyledTableCell>Hasta</StyledTableCell>
                                    <StyledTableCell></StyledTableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {this.state.rechazados.map((name) => (
                                    <StyledTableRow key={name.idInformes}>
                                        {this.state.codigosInforme.map((name2) => {
                                            if(name2.idCodigosInformesPersonal === name.codigo){
                                                desc = name2.descripcion;
                                            }
                                        })}
                                        <StyledTableCell>{desc}</StyledTableCell>
                                        <StyledTableCell>{name.estado}</StyledTableCell>
                                        <StyledTableCell>{name.anio}</StyledTableCell>
                                        <StyledTableCell>{name.numeroFuncionario}</StyledTableCell>
                                        <StyledTableCell>{name.nombreFuncionario}</StyledTableCell>
                                        <StyledTableCell>{name.desde}</StyledTableCell>
                                        <StyledTableCell>{name.hasta}</StyledTableCell>
                                        <StyledTableCell><button className="btn btn-outline-success mx-2" type='button' onClick={() => this.manejarConsultaInforme(name)}>Consultar</button></StyledTableCell>
                                    </StyledTableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </Container>
                :
                    null
                }
                {this.state.consulta && this.state.checkInforme.notificado && (!this.state.consultaEspecifica) && (!this.state.consultaEspecificaSuspender) && (!this.state.modalCancelar)
                ?
                    <Container style={{backgroundColor: '#F2F3F4'}}>
                        <Table sx={{minWidth: 700}} id="tablaConsulta">
                            <TableHead>
                                <TableRow>
                                    <StyledTableCell>Informe</StyledTableCell>
                                    <StyledTableCell>Estado</StyledTableCell>
                                    <StyledTableCell>Año</StyledTableCell>
                                    <StyledTableCell>Número</StyledTableCell>
                                    <StyledTableCell>Nombre</StyledTableCell>
                                    <StyledTableCell>Desde</StyledTableCell>
                                    <StyledTableCell>Hasta</StyledTableCell>
                                    <StyledTableCell></StyledTableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {this.state.notificados.map((name) => (
                                    <StyledTableRow key={name.idInformes}>
                                        {this.state.codigosInforme.map((name2) => {
                                            if(name2.idCodigosInformesPersonal === name.codigo){
                                                desc = name2.descripcion;
                                            }
                                        })}
                                        <StyledTableCell>{desc}</StyledTableCell>
                                        <StyledTableCell>{name.estado}</StyledTableCell>
                                        <StyledTableCell>{name.anio}</StyledTableCell>
                                        <StyledTableCell>{name.numeroFuncionario}</StyledTableCell>
                                        <StyledTableCell>{name.nombreFuncionario}</StyledTableCell>
                                        <StyledTableCell>{name.desde}</StyledTableCell>
                                        <StyledTableCell>{name.hasta}</StyledTableCell>
                                        <StyledTableCell><button className="btn btn-outline-success mx-2" type='button' onClick={() => this.manejarConsultaInforme(name)}>Consultar</button></StyledTableCell>
                                    </StyledTableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </Container>
                :
                    null
                }
                {this.state.consulta && this.state.checkInforme.pendientesJefe && (!this.state.consultaEspecifica) && (!this.state.consultaEspecificaSuspender) && (!this.state.modalCancelar)
                ?
                    <Container style={{backgroundColor: '#F2F3F4'}}>
                        <Table sx={{minWidth: 700}} id="tablaConsulta">
                            <TableHead>
                                <TableRow>
                                    <StyledTableCell>Informe</StyledTableCell>
                                    <StyledTableCell>Estado</StyledTableCell>
                                    <StyledTableCell>Año</StyledTableCell>
                                    <StyledTableCell>Número</StyledTableCell>
                                    <StyledTableCell>Nombre</StyledTableCell>
                                    <StyledTableCell>Desde</StyledTableCell>
                                    <StyledTableCell>Hasta</StyledTableCell>
                                    <StyledTableCell></StyledTableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {this.state.pendientesJefe.map((name) => (
                                    <StyledTableRow key={name.idInformes}>
                                        {this.state.codigosInforme.map((name2) => {
                                            if(name2.idCodigosInformesPersonal === name.codigo){
                                                desc = name2.descripcion;
                                            }
                                        })}
                                        <StyledTableCell>{desc}</StyledTableCell>
                                        <StyledTableCell>{name.estado}</StyledTableCell>
                                        <StyledTableCell>{name.anio}</StyledTableCell>
                                        <StyledTableCell>{name.numeroFuncionario}</StyledTableCell>
                                        <StyledTableCell>{name.nombreFuncionario}</StyledTableCell>
                                        <StyledTableCell>{name.desde}</StyledTableCell>
                                        <StyledTableCell>{name.hasta}</StyledTableCell>
                                        <StyledTableCell><button className="btn btn-outline-success mx-2" type='button' onClick={() => this.manejarConsultaInforme(name)}>Consultar</button></StyledTableCell>
                                    </StyledTableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </Container>
                :
                    null
                }
                {this.state.consulta && this.state.checkInforme.pendientesSV && (!this.state.consultaEspecifica) && (!this.state.consultaEspecificaSuspender) && (!this.state.modalCancelar)
                ?
                    <Container style={{backgroundColor: '#F2F3F4'}}>
                        <Table sx={{minWidth: 700}} id="tablaConsulta">
                            <TableHead>
                                <TableRow>
                                    <StyledTableCell>Informe</StyledTableCell>
                                    <StyledTableCell>Estado</StyledTableCell>
                                    <StyledTableCell>Año</StyledTableCell>
                                    <StyledTableCell>Número</StyledTableCell>
                                    <StyledTableCell>Nombre</StyledTableCell>
                                    <StyledTableCell>Desde</StyledTableCell>
                                    <StyledTableCell>Hasta</StyledTableCell>
                                    <StyledTableCell></StyledTableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {this.state.pendientesSV.map((name) => (
                                    <StyledTableRow key={name.idInformes}>
                                        {this.state.codigosInforme.map((name2) => {
                                            if(name2.idCodigosInformesPersonal === name.codigo){
                                                desc = name2.descripcion;
                                            }
                                        })}
                                        <StyledTableCell>{desc}</StyledTableCell>
                                        <StyledTableCell>{name.estado}</StyledTableCell>
                                        <StyledTableCell>{name.anio}</StyledTableCell>
                                        <StyledTableCell>{name.numeroFuncionario}</StyledTableCell>
                                        <StyledTableCell>{name.nombreFuncionario}</StyledTableCell>
                                        <StyledTableCell>{name.desde}</StyledTableCell>
                                        <StyledTableCell>{name.hasta}</StyledTableCell>
                                        <StyledTableCell><button className="btn btn-outline-success mx-2" type='button' onClick={() => this.manejarConsultaInforme(name)}>Consultar</button></StyledTableCell>
                                    </StyledTableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </Container>
                :
                    null
                }
                {this.state.consulta && this.state.checkInforme.pendientesPersonal && (!this.state.consultaEspecifica) && (!this.state.consultaEspecificaSuspender) && (!this.state.modalCancelar)
                ?
                    <Container style={{backgroundColor: '#F2F3F4'}}>
                        <Table sx={{minWidth: 700}} id="tablaConsulta">
                            <TableHead>
                                <TableRow>
                                    <StyledTableCell>Informe</StyledTableCell>
                                    <StyledTableCell>Estado</StyledTableCell>
                                    <StyledTableCell>Año</StyledTableCell>
                                    <StyledTableCell>Número</StyledTableCell>
                                    <StyledTableCell>Nombre</StyledTableCell>
                                    <StyledTableCell>Desde</StyledTableCell>
                                    <StyledTableCell>Hasta</StyledTableCell>
                                    <StyledTableCell></StyledTableCell>
                                    <StyledTableCell></StyledTableCell>
                                    <StyledTableCell></StyledTableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {this.state.pendientesPersonal.map((name) => (
                                    <StyledTableRow key={name.idInformes}>
                                        {this.state.codigosInforme.map((name2) => {
                                            if(name2.idCodigosInformesPersonal === name.codigo){
                                                desc = name2.descripcion;
                                            }
                                        })}
                                        <StyledTableCell>{desc}</StyledTableCell>
                                        <StyledTableCell>{name.estado}</StyledTableCell>
                                        <StyledTableCell>{name.anio}</StyledTableCell>
                                        <StyledTableCell>{name.numeroFuncionario}</StyledTableCell>
                                        <StyledTableCell>{name.nombreFuncionario}</StyledTableCell>
                                        <StyledTableCell>{name.desde}</StyledTableCell>
                                        <StyledTableCell>{name.hasta}</StyledTableCell>
                                        <StyledTableCell><button className="btn btn-outline-success mx-2" type='button' onClick={() => this.manejarConsultaInforme(name)}>Consultar</button></StyledTableCell>
                                    </StyledTableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </Container>
                :
                    null
                }
                {this.state.consulta && this.state.checkInforme.pendientesjefeRRHH && (!this.state.consultaEspecifica) && (!this.state.consultaEspecificaSuspender) && (!this.state.modalCancelar)
                ?
                    <Container style={{backgroundColor: '#F2F3F4'}}>
                        <Table sx={{minWidth: 700}} id="tablaConsulta">
                            <TableHead>
                                <TableRow>
                                    <StyledTableCell>Informe</StyledTableCell>
                                    <StyledTableCell>Estado</StyledTableCell>
                                    <StyledTableCell>Año</StyledTableCell>
                                    <StyledTableCell>Número</StyledTableCell>
                                    <StyledTableCell>Nombre</StyledTableCell>
                                    <StyledTableCell>Desde</StyledTableCell>
                                    <StyledTableCell>Hasta</StyledTableCell>
                                    <StyledTableCell></StyledTableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {this.state.pendientesjefeRRHH.map((name) => (
                                    <StyledTableRow key={name.idInformes}>
                                        {this.state.codigosInforme.map((name2) => {
                                            if(name2.idCodigosInformesPersonal === name.codigo){
                                                desc = name2.descripcion;
                                            }
                                        })}
                                        <StyledTableCell>{desc}</StyledTableCell>
                                        <StyledTableCell>{name.estado}</StyledTableCell>
                                        <StyledTableCell>{name.anio}</StyledTableCell>
                                        <StyledTableCell>{name.numeroFuncionario}</StyledTableCell>
                                        <StyledTableCell>{name.nombreFuncionario}</StyledTableCell>
                                        <StyledTableCell>{name.desde}</StyledTableCell>
                                        <StyledTableCell>{name.hasta}</StyledTableCell>
                                        <StyledTableCell><button className="btn btn-outline-success mx-2" type='button' onClick={() => this.manejarConsultaInforme(name)}>Consultar</button></StyledTableCell>
                                    </StyledTableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </Container>
                :
                    null
                }
                {this.state.consulta && this.state.checkInforme.pendienteNotificacion && (!this.state.consultaEspecifica) && (!this.state.consultaEspecificaSuspender) && (!this.state.modalCancelar)
                ?
                    <Container style={{backgroundColor: '#F2F3F4'}}>
                        <Table sx={{minWidth: 700}} id="tablaConsulta">
                            <TableHead>
                                <TableRow>
                                    <StyledTableCell>Informe</StyledTableCell>
                                    <StyledTableCell>Estado</StyledTableCell>
                                    <StyledTableCell>Año</StyledTableCell>
                                    <StyledTableCell>Número</StyledTableCell>
                                    <StyledTableCell>Nombre</StyledTableCell>
                                    <StyledTableCell>Desde</StyledTableCell>
                                    <StyledTableCell>Hasta</StyledTableCell>
                                    <StyledTableCell></StyledTableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {this.state.pendienteNotificacion.map((name) => (
                                    <StyledTableRow key={name.idInformes}>
                                        {this.state.codigosInforme.map((name2) => {
                                            if(name2.idCodigosInformesPersonal === name.codigo){
                                                desc = name2.descripcion;
                                            }
                                        })}
                                        <StyledTableCell>{desc}</StyledTableCell>
                                        <StyledTableCell>{name.estado}</StyledTableCell>
                                        <StyledTableCell>{name.anio}</StyledTableCell>
                                        <StyledTableCell>{name.numeroFuncionario}</StyledTableCell>
                                        <StyledTableCell>{name.nombreFuncionario}</StyledTableCell>
                                        <StyledTableCell>{name.desde}</StyledTableCell>
                                        <StyledTableCell>{name.hasta}</StyledTableCell>
                                        <StyledTableCell><button className="btn btn-outline-success mx-2" type='button' onClick={() => this.manejarConsultaInforme(name)}>Consultar</button></StyledTableCell>
                                    </StyledTableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </Container>
                :
                    null
                }
                {this.state.consulta && this.state.checkInforme.anulado && (!this.state.consultaEspecifica) && (!this.state.consultaEspecificaSuspender) && (!this.state.modalCancelar)
                ?
                    <Container style={{backgroundColor: '#F2F3F4'}}>
                        <Table sx={{minWidth: 700}} id="tablaConsulta">
                            <TableHead>
                                <TableRow>
                                    <StyledTableCell>Informe</StyledTableCell>
                                    <StyledTableCell>Estado</StyledTableCell>
                                    <StyledTableCell>Año</StyledTableCell>
                                    <StyledTableCell>Número</StyledTableCell>
                                    <StyledTableCell>Nombre</StyledTableCell>
                                    <StyledTableCell>Desde</StyledTableCell>
                                    <StyledTableCell>Hasta</StyledTableCell>
                                    <StyledTableCell></StyledTableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {this.state.anulado.map((name) => (
                                    <StyledTableRow key={name.idInformes}>
                                        {this.state.codigosInforme.map((name2) => {
                                            if(name2.idCodigosInformesPersonal === name.codigo){
                                                desc = name2.descripcion;
                                            }
                                        })}
                                        <StyledTableCell>{desc}</StyledTableCell>
                                        <StyledTableCell>{name.estado}</StyledTableCell>
                                        <StyledTableCell>{name.anio}</StyledTableCell>
                                        <StyledTableCell>{name.numeroFuncionario}</StyledTableCell>
                                        <StyledTableCell>{name.nombreFuncionario}</StyledTableCell>
                                        <StyledTableCell>{name.desde}</StyledTableCell>
                                        <StyledTableCell>{name.hasta}</StyledTableCell>
                                        <StyledTableCell><button className="btn btn-outline-success mx-2" type='button' onClick={() => this.manejarConsultaInforme(name)}>Consultar</button></StyledTableCell>
                                    </StyledTableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </Container>
                :
                    null
                }
                {this.state.consultaEspecifica
                ?
                    <Container style={{backgroundColor: '#F2F3F4'}}>
                        <Box sx={{ flexGrow: 1}}>
                            <Grid container spacing={2} rowSpacing={1}>
                                {this.state.codigosInforme.map((name2) => {
                                    if(name2.idCodigosInformesPersonal === this.state.datoEspecifico.codigo){
                                        desc = name2.descripcion;
                                    }
                                })}
                                <Grid item xs={4}>
                                </Grid>
                                <Grid item xs={4}>
                                    {desc}
                                </Grid>
                                <Grid item xs={4}>
                                </Grid>
                                {/*Esto va siempre */}
                                <Grid item xs={2}>
                                </Grid>
                                {this.state.datoEspecifico.codigo === 4 || this.state.datoEspecifico.codigo === 42 || this.state.datoEspecifico.codigo === 43 || this.state.datoEspecifico.codigo === 37 || this.state.datoEspecifico.codigo === 19 || this.state.datoEspecifico.codigo === 21 || this.state.datoEspecifico.codigo === 44 || this.state.datoEspecifico.codigo === 51 || this.state.datoEspecifico.codigo === 22 || this.state.datoEspecifico.codigo === 23 || this.state.datoEspecifico.codigo === 11 || this.state.datoEspecifico.codigo === 12 || this.state.datoEspecifico.codigo === 13 || this.state.datoEspecifico.codigo === 35 || this.state.datoEspecifico.codigo === 47 || this.state.datoEspecifico.codigo === 48 || this.state.datoEspecifico.codigo === 56 || this.state.datoEspecifico.codigo === 66
                                ?
                                    <Grid item xs={2}>
                                        <Item>Certificado (Imagen)</Item>
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 22 || this.state.datoEspecifico.codigo === 51 || this.state.datoEspecifico.codigo === 19 || this.state.datoEspecifico.codigo === 23 || this.state.datoEspecifico.codigo === 48 || this.state.datoEspecifico.codigo === 43 || this.state.datoEspecifico.codigo === 4 || this.state.datoEspecifico.codigo === 42 || this.state.datoEspecifico.codigo === 12 || this.state.datoEspecifico.codigo === 13 || this.state.datoEspecifico.codigo === 11 || this.state.datoEspecifico.codigo === 47 || this.state.datoEspecifico.codigo === 35 || this.state.datoEspecifico.codigo === 56 || this.state.datoEspecifico.codigo === 37 || this.state.datoEspecifico.codigo === 66 || this.state.datoEspecifico.codigo === 21
                                ?
                                    <Grid item xs={2}>
                                        <button className="btn btn-outline-danger mx-2" type='button' onClick={() => this.manejarModalImagen(this.state.datoEspecifico.archivoBPS)}>Ver</button>
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 75
                                ?
                                    <Grid item xs={2}>
                                        <Item>Comprobante (Imagen)</Item>
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 75
                                ?
                                    <Grid item xs={2}>
                                        <button className="btn btn-outline-danger mx-2" type='button' onClick={() => this.manejarModalImagen(this.state.datoEspecifico.archivoBPS)}>Ver</button>
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 4 || this.state.datoEspecifico.codigo === 42 || this.state.datoEspecifico.codigo === 43 || this.state.datoEspecifico.codigo === 37 || this.state.datoEspecifico.codigo === 19 || this.state.datoEspecifico.codigo === 21 || this.state.datoEspecifico.codigo === 44 || this.state.datoEspecifico.codigo === 51 || this.state.datoEspecifico.codigo === 22 || this.state.datoEspecifico.codigo === 23 || this.state.datoEspecifico.codigo === 11 || this.state.datoEspecifico.codigo === 12 || this.state.datoEspecifico.codigo === 13 || this.state.datoEspecifico.codigo === 35 || this.state.datoEspecifico.codigo === 47 || this.state.datoEspecifico.codigo === 48 || this.state.datoEspecifico.codigo === 56 || this.state.datoEspecifico.codigo === 66
                                ?
                                    <Grid item xs={1}>

                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 11 || this.state.datoEspecifico.codigo === 12 || this.state.datoEspecifico.codigo === 13
                                ?
                                    <Grid item xs={2}>
                                        <Item>Certificado De Parentesco (Imagen)</Item>
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 12 || this.state.datoEspecifico.codigo === 13 || this.state.datoEspecifico.codigo === 11
                                ?
                                    <Grid item xs={2}>
                                        <button className="btn btn-outline-danger mx-2" type='button' onClick={() => this.manejarModalImagen(this.state.datoEspecifico.archivoActa)}>Ver</button>
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 11 || this.state.datoEspecifico.codigo === 12 || this.state.datoEspecifico.codigo === 13
                                ?
                                    <Grid item xs={1}>

                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 11 || this.state.datoEspecifico.codigo === 12 || this.state.datoEspecifico.codigo === 13
                                ?
                                    <Grid item xs={2}>
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 4 || this.state.datoEspecifico.codigo === 42 || this.state.datoEspecifico.codigo === 11 || this.state.datoEspecifico.codigo === 12 || this.state.datoEspecifico.codigo === 13
                                ?
                                    <Grid item xs={2}>
                                        <Item>Familiar</Item>
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 11 || this.state.datoEspecifico.codigo === 42 || this.state.datoEspecifico.codigo === 12 || this.state.datoEspecifico.codigo === 13 || this.state.datoEspecifico.codigo === 4
                                ?
                                    <Grid item xs={2}>
                                        {this.state.datoEspecifico.familiar}
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 4 || this.state.datoEspecifico.codigo === 42 || this.state.datoEspecifico.codigo === 11 || this.state.datoEspecifico.codigo === 12 || this.state.datoEspecifico.codigo === 13
                                ?
                                    <Grid item xs={1}>

                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 4|| this.state.datoEspecifico.codigo === 42
                                ?
                                    <Grid item xs={2}>

                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo !== 110 && this.state.datoEspecifico.codigo !== 75
                                ?
                                    <Grid item xs={2}>
                                        <Item>{this.state.datoEspecifico.codigo === 43 || this.state.datoEspecifico.codigo === 19 || this.state.datoEspecifico.codigo === 10 || this.state.datoEspecifico.codigo === 21 || this.state.datoEspecifico.codigo === 106 || this.state.datoEspecifico.codigo === 109 || this.state.datoEspecifico.codigo === 37 || this.state.datoEspecifico.codigo === 110 || this.state.datoEspecifico.codigo === 62 ? 'Día' : 'Desde'}</Item>
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo !== 110 && this.state.datoEspecifico.codigo !== 61 && this.state.datoEspecifico.codigo !== 75
                                ?
                                    <Grid item xs={2}>
                                        {this.state.datoEspecifico.desde}
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 61
                                ?
                                    <Grid item xs={2}>
                                        {this.state.datoEspecifico.marca1}
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo !== 110
                                ?
                                    <Grid item xs={1}>

                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 10
                                ?
                                    <Grid item xs={2}>
                                        <Item>Nueva Dirección</Item>
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 10
                                ?
                                    <Grid item xs={2}>
                                        {this.state.datoEspecifico.juzgado}
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 35 || this.state.datoEspecifico.codigo === 37 || this.state.datoEspecifico.codigo === 56
                                ?
                                    <Grid item xs={2}>

                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 22 || this.state.datoEspecifico.codigo === 51 || this.state.datoEspecifico.codigo === 23 || this.state.datoEspecifico.codigo === 48 || this.state.datoEspecifico.codigo === 11 || this.state.datoEspecifico.codigo === 47 || this.state.datoEspecifico.codigo === 66 || this.state.datoEspecifico.codigo === 12 || this.state.datoEspecifico.codigo === 13
                                ?
                                    <Grid item xs={2}>
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo !== 75 && this.state.datoEspecifico.codigo !== 62 && this.state.datoEspecifico.codigo !== 43 && this.state.datoEspecifico.codigo !== 19 && this.state.datoEspecifico.codigo !== 10 && this.state.datoEspecifico.codigo !== 21 && this.state.datoEspecifico.codigo !== 106 && this.state.datoEspecifico.codigo !== 109 && this.state.datoEspecifico.codigo !== 110 && this.state.datoEspecifico.codigo !== 37
                                ?
                                    <Grid item xs={2}>
                                        <Item>Hasta</Item>
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo !== 75 && this.state.datoEspecifico.codigo !== 62 && this.state.datoEspecifico.codigo !== 61 && this.state.datoEspecifico.codigo !== 43 && this.state.datoEspecifico.codigo !== 19 && this.state.datoEspecifico.codigo !== 10 && this.state.datoEspecifico.codigo !== 21 && this.state.datoEspecifico.codigo !== 106 && this.state.datoEspecifico.codigo !== 109 && this.state.datoEspecifico.codigo !== 110 && this.state.datoEspecifico.codigo !== 37
                                ?
                                    <Grid item xs={2}>
                                        {this.state.datoEspecifico.hasta}
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 61
                                ?
                                    <Grid item xs={2}>
                                        {this.state.datoEspecifico.marca2}
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo !== 62 && this.state.datoEspecifico.codigo !== 43 && this.state.datoEspecifico.codigo !== 19 && this.state.datoEspecifico.codigo !== 10 && this.state.datoEspecifico.codigo !== 21 && this.state.datoEspecifico.codigo !== 106 && this.state.datoEspecifico.codigo !== 109 && this.state.datoEspecifico.codigo !== 110 && this.state.datoEspecifico.codigo !== 37
                                ?
                                <Grid item xs={1}>

                                </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 61
                                ?
                                    <Grid item xs={2}>
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 61
                                ?
                                    <Grid item xs={2}>
                                        <Item>Día</Item>
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 61
                                ?
                                    <Grid item xs={2}>
                                        {this.state.datoEspecifico.desde}
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 71 || this.state.datoEspecifico.codigo === 1 || this.state.datoEspecifico.codigo === 67 || this.state.datoEspecifico.codigo === 40 || this.state.datoEspecifico.codigo === 16 || this.state.datoEspecifico.codigo === 17 || this.state.datoEspecifico.codigo === 29 || this.state.datoEspecifico.codigo === 5 || this.state.datoEspecifico.codigo === 52 || this.state.datoEspecifico.codigo === 14 || this.state.datoEspecifico.codigo === 15 || this.state.datoEspecifico.codigo === 20
                                ?
                                    <Grid item xs={2}>
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo !== 75 && this.state.datoEspecifico.codigo !== 62 && this.state.datoEspecifico.codigo !== 61 && this.state.datoEspecifico.codigo !== 4 && this.state.datoEspecifico.codigo !== 46 && this.state.datoEspecifico.codigo !== 28 && this.state.datoEspecifico.codigo !== 42 && this.state.datoEspecifico.codigo !== 43 && this.state.datoEspecifico.codigo !== 19 && this.state.datoEspecifico.codigo !== 10 && this.state.datoEspecifico.codigo !== 21 && this.state.datoEspecifico.codigo !== 44 && this.state.datoEspecifico.codigo !== 11 && this.state.datoEspecifico.codigo !== 12 && this.state.datoEspecifico.codigo !== 13 && this.state.datoEspecifico.codigo !== 106 && this.state.datoEspecifico.codigo !== 109 && this.state.datoEspecifico.codigo !== 110 && this.state.datoEspecifico.codigo !== 47 && this.state.datoEspecifico.codigo !== 66
                                ?    
                                    <Grid item xs={2}>
                                        <Item>Días</Item>
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo !== 75 && this.state.datoEspecifico.codigo !== 62 && this.state.datoEspecifico.codigo !== 61 && this.state.datoEspecifico.codigo !== 4 && this.state.datoEspecifico.codigo !== 46 && this.state.datoEspecifico.codigo !== 28 && this.state.datoEspecifico.codigo !== 42 && this.state.datoEspecifico.codigo !== 43 && this.state.datoEspecifico.codigo !== 19 && this.state.datoEspecifico.codigo !== 10 && this.state.datoEspecifico.codigo !== 21 && this.state.datoEspecifico.codigo !== 44 && this.state.datoEspecifico.codigo !== 11 && this.state.datoEspecifico.codigo !== 12 && this.state.datoEspecifico.codigo !== 13 && this.state.datoEspecifico.codigo !== 106 && this.state.datoEspecifico.codigo !== 109 && this.state.datoEspecifico.codigo !== 110 && this.state.datoEspecifico.codigo !== 47 && this.state.datoEspecifico.codigo !== 66
                                ?  
                                    <Grid item xs={2}>
                                        {this.state.datoEspecifico.dias}
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 14 || this.state.datoEspecifico.codigo === 15 || this.state.datoEspecifico.codigo === 20 || this.state.datoEspecifico.codigo === 5 || this.state.datoEspecifico.codigo === 52
                                ?
                                    <Grid item xs={1}>
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 5 || this.state.datoEspecifico.codigo === 52
                                ?
                                    <Grid item xs={2}>
                                        <Item>Asignatura</Item>
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 5 || this.state.datoEspecifico.codigo === 52
                                ?
                                    <Grid item xs={2}>
                                        {this.state.datoEspecifico.juzgado}
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 20
                                ?
                                    <Grid item xs={2}>
                                        <Item>Documento</Item>
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 20
                                ?
                                    <Grid item xs={2}>
                                        <button className="btn btn-outline-danger mx-2" type='button' onClick={() => this.manejarModalImagen(this.state.datoEspecifico.archivoBPS)}>Ver</button>
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 14 || this.state.datoEspecifico.codigo === 15
                                ?
                                    <Grid item xs={2}>
                                        <Item>Justificativo/Invitación</Item>
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 14 || this.state.datoEspecifico.codigo === 15
                                ?
                                    <Grid item xs={2}>
                                        <button className="btn btn-outline-danger mx-2" type='button' onClick={() => this.manejarModalImagen(this.state.datoEspecifico.archivoBPS)}>Ver</button>
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 14 || this.state.datoEspecifico.codigo === 15
                                ?
                                    <Grid item xs={1}>
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 14 || this.state.datoEspecifico.codigo === 15
                                ?
                                    <Grid item xs={2}>
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 14 || this.state.datoEspecifico.codigo === 15
                                ?
                                    <Grid item xs={2}>
                                        <Item>Motivo</Item>
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 14 || this.state.datoEspecifico.codigo === 15
                                ?
                                    <Grid item xs={2}>
                                        {this.state.datoEspecifico.juzgado}
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 14 || this.state.datoEspecifico.codigo === 15
                                ?
                                    <Grid item xs={1}>
                                    </Grid>
                                :
                                    null
                                }
                                {(this.state.datoEspecifico.codigo === 71) || (this.state.datoEspecifico.codigo === 1) || (this.state.datoEspecifico.codigo === 67) || (this.state.datoEspecifico.codigo === 2) || (this.state.datoEspecifico.codigo === 37) || (this.state.datoEspecifico.codigo === 40) || (this.state.datoEspecifico.codigo === 35) || (this.state.datoEspecifico.codigo === 56) || (this.state.datoEspecifico.codigo === 14) || (this.state.datoEspecifico.codigo === 15) || (this.state.datoEspecifico.codigo === 16) || (this.state.datoEspecifico.codigo === 17) || (this.state.datoEspecifico.codigo === 20)
                                ?  
                                    <Grid item xs={1}>
                                        
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.horasEntradas.map((name) => {
                                    if(this.state.datoEspecifico.entrada === name.idEntrada){
                                        entradaIn = name.descripcion;
                                }})}
                                {this.state.horasEntradas.map((name) => {
                                    if(this.state.datoEspecifico.salida === name.idEntrada){
                                        salidaIn = name.descripcion;
                                }})}
                                {this.state.datoEspecifico.codigo === 71
                                ?
                                    <Grid item xs={2}>
                                        <Item>Entrada</Item>
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 71
                                ?
                                    <Grid item xs={2}>
                                        {entradaIn}
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 71
                                ?
                                    <Grid item xs={1}>
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 71
                                ?
                                    <Grid item xs={2}>
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 71
                                ?
                                    <Grid item xs={2}>
                                        <Item>Salida</Item>
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 71
                                ?
                                    <Grid item xs={2}>
                                        {salidaIn}
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 71
                                ?
                                    <Grid item xs={1}>
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo !== 75 && this.state.datoEspecifico.codigo !== 62 && this.state.datoEspecifico.codigo !== 71 && this.state.datoEspecifico.codigo !== 61 && this.state.datoEspecifico.codigo !== 14 && this.state.datoEspecifico.codigo !== 16 && this.state.datoEspecifico.codigo !== 17 && this.state.datoEspecifico.codigo !== 15 && this.state.datoEspecifico.codigo !== 4 && this.state.datoEspecifico.codigo !== 29 && this.state.datoEspecifico.codigo !== 46 && this.state.datoEspecifico.codigo !== 28 && this.state.datoEspecifico.codigo !== 42 && this.state.datoEspecifico.codigo !== 43 && this.state.datoEspecifico.codigo !== 37 && this.state.datoEspecifico.codigo !== 19 && this.state.datoEspecifico.codigo !== 10 && this.state.datoEspecifico.codigo !== 21 && this.state.datoEspecifico.codigo !== 44 && this.state.datoEspecifico.codigo !== 51 && this.state.datoEspecifico.codigo !== 22 && this.state.datoEspecifico.codigo !== 23 && this.state.datoEspecifico.codigo !== 20 && this.state.datoEspecifico.codigo !== 57 && this.state.datoEspecifico.codigo !== 11 && this.state.datoEspecifico.codigo !== 12 && this.state.datoEspecifico.codigo !== 13 && this.state.datoEspecifico.codigo !== 35 && this.state.datoEspecifico.codigo !== 106 && this.state.datoEspecifico.codigo !== 107 && this.state.datoEspecifico.codigo !== 109 && this.state.datoEspecifico.codigo !== 108 && this.state.datoEspecifico.codigo !== 5 && this.state.datoEspecifico.codigo !== 52 && this.state.datoEspecifico.codigo !== 110 && this.state.datoEspecifico.codigo !== 47 && this.state.datoEspecifico.codigo !== 48 && this.state.datoEspecifico.codigo !== 56 && this.state.datoEspecifico.codigo !== 66
                                ?    
                                    <Grid item xs={2}>
                                        <Item>Ejercicio (AÑO)</Item>
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo !== 75 && this.state.datoEspecifico.codigo !== 62 && this.state.datoEspecifico.codigo !== 71 && this.state.datoEspecifico.codigo !== 61 && this.state.datoEspecifico.codigo !== 14 && this.state.datoEspecifico.codigo !== 16 && this.state.datoEspecifico.codigo !== 17 && this.state.datoEspecifico.codigo !== 15 && this.state.datoEspecifico.codigo !== 4 && this.state.datoEspecifico.codigo !== 29 && this.state.datoEspecifico.codigo !== 46 && this.state.datoEspecifico.codigo !== 28 && this.state.datoEspecifico.codigo !== 42 && this.state.datoEspecifico.codigo !== 43 && this.state.datoEspecifico.codigo !== 37 && this.state.datoEspecifico.codigo !== 19 && this.state.datoEspecifico.codigo !== 10 && this.state.datoEspecifico.codigo !== 21 && this.state.datoEspecifico.codigo !== 44 && this.state.datoEspecifico.codigo !== 51 && this.state.datoEspecifico.codigo !== 22 && this.state.datoEspecifico.codigo !== 23 && this.state.datoEspecifico.codigo !== 20 && this.state.datoEspecifico.codigo !== 57 && this.state.datoEspecifico.codigo !== 11 && this.state.datoEspecifico.codigo !== 12 && this.state.datoEspecifico.codigo !== 13 && this.state.datoEspecifico.codigo !== 35 && this.state.datoEspecifico.codigo !== 106 && this.state.datoEspecifico.codigo !== 107 && this.state.datoEspecifico.codigo !== 109 && this.state.datoEspecifico.codigo !== 108 && this.state.datoEspecifico.codigo !== 5 && this.state.datoEspecifico.codigo !== 52 && this.state.datoEspecifico.codigo !== 110 && this.state.datoEspecifico.codigo !== 47 && this.state.datoEspecifico.codigo !== 48 && this.state.datoEspecifico.codigo !== 56 && this.state.datoEspecifico.codigo !== 66
                                ?  
                                    <Grid item xs={2}>
                                        {this.state.datoEspecifico.anio}
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 2 && this.state.datoEspecifico.codigo !== 106 && this.state.datoEspecifico.codigo !== 109
                                ?  
                                    <Grid item xs={1}>
                                        
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 35 || this.state.datoEspecifico.codigo === 28 || this.state.datoEspecifico.codigo === 46
                                ?
                                    <Grid item xs={2}>

                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 35 || this.state.datoEspecifico.codigo === 37 || this.state.datoEspecifico.codigo === 106 || this.state.datoEspecifico.codigo === 109 || this.state.datoEspecifico.codigo === 28 || this.state.datoEspecifico.codigo === 46 || this.state.datoEspecifico.codigo === 110
                                ?    
                                    <Grid item xs={2}>
                                        <Item>Minutos</Item>
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 110 || this.state.datoEspecifico.codigo === 35 || this.state.datoEspecifico.codigo === 37 || this.state.datoEspecifico.codigo === 106 || this.state.datoEspecifico.codigo === 109 || this.state.datoEspecifico.codigo === 28 || this.state.datoEspecifico.codigo === 46
                                ?  
                                    <Grid item xs={2}>
                                        {this.state.datoEspecifico.minutos}
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 110 || this.state.datoEspecifico.codigo === 35 || this.state.datoEspecifico.codigo === 37 || this.state.datoEspecifico.codigo === 28 || this.state.datoEspecifico.codigo === 46
                                ?  
                                    <Grid item xs={1}>
                                        
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 35
                                ?    
                                    <Grid item xs={2}>
                                        <Item>Juzgado</Item>
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 35
                                ?  
                                    <Grid item xs={2}>
                                        {this.state.datoEspecifico.juzgado}
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 35 || this.state.datoEspecifico.codigo === 106 || this.state.datoEspecifico.codigo === 109
                                ?  
                                    <Grid item xs={1}>
                                        
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 35 || this.state.datoEspecifico.codigo === 37
                                ?
                                    <Grid item xs={2}>

                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 35 || this.state.datoEspecifico.codigo === 37 || this.state.datoEspecifico.codigo === 28 || this.state.datoEspecifico.codigo === 46
                                ?    
                                    <Grid item xs={2}>
                                        <Item>Tipo Salida</Item>
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 35 || this.state.datoEspecifico.codigo === 28 || this.state.datoEspecifico.codigo === 46 || this.state.datoEspecifico.codigo === 37
                                ?  
                                    <Grid item xs={2}>
                                        {this.state.datoEspecifico.tipoSalida}
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 37
                                ?  
                                    <Grid item xs={2}>
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 35 || this.state.datoEspecifico.codigo === 28 || this.state.datoEspecifico.codigo === 46
                                ?  
                                    <Grid item xs={1}>
                                        
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 106
                                ?    
                                    <Grid item xs={2.1}>
                                        <Item>Entrada</Item>
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 106
                                ?  
                                    <Grid item xs={2}>
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 106
                                ?  
                                    <Grid item xs={1}>
                                        
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 106
                                ?    
                                    <Grid item xs={2.1}>
                                        <Item>Salilda</Item>
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 106
                                ?  
                                    <Grid item xs={2}>
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 106
                                ?  
                                    <Grid item xs={1}>
                                        
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 106
                                ?    
                                    <Grid item xs={2.1}>
                                        <Item>Entrada</Item>
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 106
                                ?  
                                    <Grid item xs={2}>
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 106 || this.state.datoEspecifico.codigo === 109
                                ?  
                                    <Grid item xs={1}>
                                        
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 109
                                ?
                                    <Grid item xs={2.1}>
                                        <Item>Concepto</Item>
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 109
                                ?
                                    <Grid item xs={2.1}>
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 106
                                ?    
                                    <Grid item xs={2.1}>
                                        <Item>Salilda</Item>
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 106
                                ?  
                                    <Grid item xs={2}>
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 106 || this.state.datoEspecifico.codigo === 109
                                ?  
                                    <Grid item xs={1}>
                                        
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 110
                                ?
                                    <Grid item xs={2}>
                                        <Item>Día</Item>
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 110
                                ?
                                    <Grid item xs={2}>
                                        {this.state.datoEspecifico.desde}
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 110
                                ?
                                    <Grid item xs={1}>

                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 62
                                ?
                                    <Grid item xs={2}>
                                        <Item>Tipo Omisión</Item>
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 62
                                ?
                                    <Grid item xs={2}>
                                        {this.state.datoEspecifico.tipoSalida}
                                    </Grid>
                                :
                                    null
                                }
                            </Grid>
                        </Box>
                        {this.state.datoEspecifico.codigo === 110
                        ?
                            <br/>
                        :
                            null
                        }
                        {this.state.datoEspecifico.codigo === 110 ? <textarea style={{width:"100%", border:"2px solid #D6EAF8"}} rows={5} cols={20} id='comentarios' value={this.state.datoEspecifico.comentarios} disabled/> : null}
                        {this.state.datoEspecifico.motivoRechazo !== '' ? <textarea style={{width:"100%", border:"2px solid #D6EAF8"}} rows={10} cols={40} id='motivoRechazo' value={this.state.datoEspecifico.motivoRechazo} disabled/> : null}
                        <button className="btn btn-outline-primary mx-2" style={{marginTop:'2rem'}} type='button' onClick={this.manejarAtrasEspecifica}>Volver</button>
                    </Container>
                :
                    null
                }
                {this.state.imagenMostrarModal
                ?
                    <Modal open={this.state.imagenMostrarModal}>
                        <Box sx={styleModal} >
                            <Grid container spacing={2} rowSpacing={1}>
                                <img src={this.state.imagenMostrar} alt="" style={{ width: '90%'}}/>
                                <Grid item xs={5}>
                                    
                                </Grid>
                                <Grid item xs={2}>
                                    <button className="btn btn-outline-primary mx-2" style={{marginTop:'2rem'}} type='button' onClick={this.manejarCerrarModal}>Cerrar</button>
                                </Grid>
                            </Grid>
                        </Box>
                    </Modal>
                :
                    null
                }
                {this.state.consulta && (!this.state.consultaEspecifica) && (!this.state.consultaEspecificaSuspender) && (!this.state.modalCancelar)
                ?
                    <button className="btn btn-outline-primary mx-2" style={{marginTop:'2rem'}} type='button' onClick={this.manejarAtras}>Volver</button>
                :
                    null
                }
            </>
        )
    }
    
    manejarCambiosDatos(e){
        e.preventDefault();
        const clave = e.target.id;
        let valor = e.target.value;
        this.setState({
            errores: null,
            notificaciones: null,
        });
        this.setState(state => {
            const numFunActualizado = state.busqueda;
            numFunActualizado[clave] = valor;
            
            if(clave === 'numeroFuncionario'){
                //valor = parseFloat(valor);
                //Tengo que buscar la informacion de ese funcionario
                let aux = true;
                this.state.numeroNombre.map((name) =>
                {if(name.numeroFuncionario === valor){
                    numFunActualizado['nombreFuncionario'] = name.primerNombre + ' ' + name.primerApellido;
                    aux = false;
                }else if(aux){
                    numFunActualizado['nombreFuncionario'] = '';
                }
                });
            }
            
            return{
                busqueda: numFunActualizado,
            };
        });
    }

    async manejoEnvioConsulta(){
        if((this.state.busqueda.numeroFuncionario !== '') && (this.state.busqueda.nombreFuncionario === '')){
            this.setState({
                errores: 'Ingrese un número de funcionario valido',
            })
        }else{
            this.setState({
                loading: true,
            });
            const cargaUtil = JSON.stringify([this.state.busqueda]);
            const respuesta = await fetch(`${Constantes.RUTA_API}/obtener_informesConsultaSV.php`,{
                method: 'POST',
                body: cargaUtil,
            })
            const exito = await respuesta.json();
            this.setState({
                loading: false,
                errores: exito[0],
            })

            if(exito[0] === 'ok'){
                this.setState({
                    consulta: true,
                    errores: null,
                    notificaciones: null,
                    todosInformes: exito[1],
                    notificados: exito[2],
                    rechazados: exito[3],
                    pendientesJefe: exito[4],
                    pendientesSV: exito[5],
                    pendientesPersonal: exito[6],
                    pendientesjefeRRHH: exito[7],
                    pendienteNotificacion: exito[8],
                    anulado: exito[9],
                })
            }
        }
    }

    cambioListadoConsulta(e){
        const clave = e.target.id;
        let valor = e.target.checked;
        this.setState({
            errores: null,
            notificaciones: null,
        });

        if(clave === 'todo'){

            if(valor){
                this.setState({
                    checkInforme: {
                        todo: true,
                        notificado: false,
                        rechazado: false,
                        pendientesJefe: false,
                        pendientesSV: false,
                        pendientesPersonal: false,
                        pendientesjefeRRHH: false,
                        pendienteNotificacion: false,
                        anulado: false,
                    },
                });
            }
        }else if(clave === 'notificado'){

            if(valor){
                this.setState({
                    checkInforme: {
                        todo: false,
                        notificado: true,
                        rechazado: false,
                        pendientesJefe: false,
                        pendientesSV: false,
                        pendientesPersonal: false,
                        pendientesjefeRRHH: false,
                        pendienteNotificacion: false,
                        anulado: false,
                    },
                });
            }
        }else if(clave === 'rechazado'){

            if(valor){
                this.setState({
                    checkInforme: {
                        todo: false,
                        notificado: false,
                        rechazado: true,
                        pendientesJefe: false,
                        pendientesSV: false,
                        pendientesPersonal: false,
                        pendientesjefeRRHH: false,
                        pendienteNotificacion: false,
                        anulado: false,
                    },
                });
            }
        }else if(clave === 'pendientesJefe'){

            if(valor){
                this.setState({
                    checkInforme: {
                        todo: false,
                        notificado: false,
                        rechazado: false,
                        pendientesJefe: true,
                        pendientesSV: false,
                        pendientesPersonal: false,
                        pendientesjefeRRHH: false,
                        pendienteNotificacion: false,
                        anulado: false,
                    },
                });
            }
        }else if(clave === 'pendientesSV'){

            if(valor){
                this.setState({
                    checkInforme: {
                        todo: false,
                        notificado: false,
                        rechazado: false,
                        pendientesJefe: false,
                        pendientesSV: true,
                        pendientesPersonal: false,
                        pendientesjefeRRHH: false,
                        pendienteNotificacion: false,
                        anulado: false,
                    },
                });
            }
        }else if(clave === 'pendientesPersonal'){

            if(valor){
                this.setState({
                    checkInforme: {
                        todo: false,
                        notificado: false,
                        rechazado: false,
                        pendientesJefe: false,
                        pendientesSV: false,
                        pendientesPersonal: true,
                        pendientesjefeRRHH: false,
                        pendienteNotificacion: false,
                        anulado: false,
                    },
                });
            }
        }else if(clave === 'pendientesjefeRRHH'){

            if(valor){
                this.setState({
                    checkInforme: {
                        todo: false,
                        notificado: false,
                        rechazado: false,
                        pendientesJefe: false,
                        pendientesSV: false,
                        pendientesPersonal: false,
                        pendientesjefeRRHH: true,
                        pendienteNotificacion: false,
                        anulado: false,
                    },
                });
            }
        }else if(clave === 'pendienteNotificacion'){

            if(valor){
                this.setState({
                    checkInforme: {
                        todo: false,
                        notificado: false,
                        rechazado: false,
                        pendientesJefe: false,
                        pendientesSV: false,
                        pendientesPersonal: false,
                        pendientesjefeRRHH: false,
                        pendienteNotificacion: true,
                        anulado: false,
                    },
                });
            }
        }else if(clave === 'anulado'){

            if(valor){
                this.setState({
                    checkInforme: {
                        todo: false,
                        notificado: false,
                        rechazado: false,
                        pendientesJefe: false,
                        pendientesSV: false,
                        pendientesPersonal: false,
                        pendientesjefeRRHH: false,
                        pendienteNotificacion: false,
                        anulado: true,
                    },
                });
            }
        }
    }

    manejarConsultaInforme(dato){
        this.setState({
            errores: null,
            notificaciones: null,
            consultaEspecifica: true,
            consultaEspecificaSuspender: false,
            datoEspecifico: dato,
        })
    }

    manejarModalImagen(dato){
        this.setState({
            imagenMostrarModal: true,
            imagenMostrar: dato,
        })
    }

    manejarCerrarModal(e){
        e.preventDefault();
        this.setState({
            imagenMostrarModal: false,
            imagenMostrar: '',
        })
    }

    manejarAtras(e){
        e.preventDefault();
        this.setState({
            consulta: false,
            errores: null,
            notificaciones: null,

            busqueda: {
                numeroFuncionario: '',
                nombreFuncionario: '',
                codigo: '',
                ubicacion: '',
                ubicacionCentral: '',
                anio: '',
                mes: '',
                desde: '',
            },

            checkInforme: {
                todo: true,
                rechazado: false,
                notificado: false,
                pendientesJefe: false,
                pendientesSV: false,
                pendientesPersonal: false,
                pendientesjefeRRHH: false,
                pendienteNotificacion: false,
                anulado: false,
            },
        })
    }

    manejarAtrasEspecifica(e){
        e.preventDefault();
        this.setState({
            errores: null,
            notificaciones: null,
            consultaEspecifica: false,
            consultaEspecificaSuspender: false,
            datoEspecifico: {},
            modalCancelar: false,
        })
    }
}

export default ConsultasInformesSV